<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{ 'iotemeter.performance_analytics.usage_data' | translate }}
				<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportUsageData()"
					*ngIf="!usageDataIsEmpty"></button>
			</h4>
		</div>
	</div>

	<!-- date filter -->
	<div class="row col-xl-7 mb-4">
		<div class="col-xl-6 col-md-6">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="minDate">
				<div class="input-group-append pointer" (click)="d1.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>

		<div class="col-xl-6 col-md-6">
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate" [maxDate]="maxDate">
				<div class="input-group-append pointer" (click)="d2.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
	</div>

	<div class="container" *ngIf="!usageDataIsEmpty; else noData">
		<div class="row">
			<div class="col-6 mb-3" *ngFor="let item of usageData">
				<div class="card">
					<div class="card-body main-bg">
						<div *ngIf="item?.length">
							<div class="row">
								<div class="col-6">
									<h4 class="card-title text-center">
										{{ item[0].value }} {{ item[0].unit }}
									</h4>
									<p class="card-text text-center"> {{ item[0].label }} </p>
								</div>
								<div class="col-6">
									<h4 class="card-title text-center">
										{{ item[1].value }} {{ item[1].unit }}
									</h4>
									<p class="card-text text-center"> {{ item[1].label }} </p>
								</div>
							</div>
						</div>
						<div *ngIf="!item?.length">
							<h4 class="card-title text-center">
								{{ item.value }} {{ item.unit }}
							</h4>
							<p class="card-text text-center"> {{ item.label }} </p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #noData>
	{{'g.no_data_available_for_the_selected_period' | translate}}
</ng-template>
